import { Component, OnInit } from '@angular/core';
import { Entitlement } from '../../shared/models/entitlement';
import { DataService } from '../../shared/services/data-service/data.service';
import { StoreService } from '../../shared/services/store-service/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../../shared/models/client';
import { Service } from '../../shared/models/service';
import { Breadcrumbs } from '../../shared/models/breadcrumbs';
import { EventService } from 'src/app/shared/services/event-service/event.service';

@Component({
  selector: 'app-entitlement-service',
  templateUrl: './entitlement-service.component.html',
  styleUrls: ['../../app.component.css', './entitlement-service.component.css'],
})
export class EntitlementServiceComponent implements OnInit {
  serviceId: string;
  service: Service | undefined;
  entitlementServiceKeys: { [key: string]: { [key: string]: string[] } } = {};
  entitlementServices: Entitlement[] = [];
  clients: Client[] = [];
  entitlementKey: string[] = [];
  loading: boolean;
  searchString: string = '';
  showModalBox: boolean = false;
  client: Client; // client-input
  expandClientId: string = '';
  breadcrumbItems: Breadcrumbs[];
  isOkButtonDisabled: boolean;
  clientName: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    public storeService: StoreService,
    private eventService: EventService,
  ) {
    this.loading = true;
  }

  async ngOnInit(): Promise<void> {
    try {
      this.isOkButtonDisabled = true;
      await this.dataService.initServices();
      await this.dataService.initClients();
      this.serviceId = this.route.snapshot.paramMap.get('serviceId') || '';
      this.service = this.storeService.services.find(
        (a) => a.id == this.serviceId,
      );
      await this.dataService.initEntitlementByServiceId(this.serviceId);
    } catch (error) {
      this.loading = false;
    }
    this.entitlementServices = this.storeService.entitlementServices;

    // Get Entitlement Key
    this.entitlementKey = [];
    this.storeService.services
      .filter((a) => a.id == this.serviceId)
      .forEach((service) => {
        service.serviceKeys
          .sort((a, b) => a.priority - b.priority)
          .forEach((key) => {
            this.entitlementKey.push(key.key);
          });
      });

    if (this.entitlementServices != null) {
      this.entitlementServices
        .filter((a) => a.serviceId == this.serviceId)
        .forEach((x) => {
          if (this.clients.filter((a) => a.id == x.clientId).length === 0) {
            let client = new Client();
            client.id = x.clientId;
            client.name = this.storeService.clients.find(
              (c) => c.id == x.clientId,
            )?.name!;
            this.clients.push(client);
            // expand for first client
            if (this.expandClientId == '') {
              this.expandClientId = client.id;
            }
          }
          this.entitlementServiceKeys[x.clientId] = this.groupByKey(
            x.entitlements,
            this.entitlementKey[0],
          );
        });
    }
    this.buildBreadcrumbs();
    this.loading = false;

    //Event subscription
    this.eventService.auth0ClientDataIncomingEvent.subscribe(
      (client: Client[]) => {
        if (client[0].id == null) {
          this.clientName = 'Client not found';
          this.isOkButtonDisabled = true;
        } else {
          this.client = client[0];
          this.clientName = 'Client found: ' + client[0].name;
          this.isOkButtonDisabled = false;
        }
      },
    );
  }

  buildBreadcrumbs() {
    this.breadcrumbItems = [
      {
        text: 'Service',
        link: '/service',
      },
      {
        text: this.service?.name!,
        link: '/entitlement-service/' + this.serviceId,
      },
    ];
  }

  clearSearch() {
    this.searchString = '';
  }

  getValues(datas: any[], key: string) {
    let result: string[] = [];
    datas.forEach((data, i) => {
      result.push(data['data'][key]);
    });
    return result.join(', ');
  }

  getDescription(datas: any[], key: string) {
    let result: string[] = [];
    datas.forEach((data, i) => {
      if (data['description'][key]) result.push(data['description'][key]);
    });
    if (result.length > 0) return result.join(', ');
    return 'No Description';
  }

  groupByKey(array: any[], key: string) {
    return array.reduce((hash, obj) => {
      if (obj['data'][key] === undefined) return hash;
      return Object.assign(hash, {
        [obj['data'][key]]: (hash[obj['data'][key]] || []).concat(obj),
      });
    }, {});
  }

  async addClient() {
    this.showModalBox = false;
    this.loading = true;
    await this.dataService.addClient(this.client);
    this.storeService.addClient(this.client);
    this.router.navigate([
      '/entitlement-service-client',
      this.client.id,
      this.serviceId,
    ]);
  }

  async showClient() {
    this.showModalBox = true;
  }

  expand(clientId: string) {
    this.expandClientId = this.expandClientId == clientId ? '' : clientId;
  }
}
